// import Cookies from 'js-cookie'
import {access_token} from "@/utils/baseConfig";

const TokenKey = access_token
const UserInfo = 'UserInfo'

// token
export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}

// userInfo
export function getUserInfo() {
  return JSON.parse(localStorage.getItem(UserInfo))
}

export function setUserInfo(userInfo) {
  let userInfoStr = JSON.stringify(userInfo)
  return localStorage.setItem(UserInfo, userInfoStr)
}

export function removeUserInfo() {
  return localStorage.removeItem(UserInfo)
}
